import React from "react";
import * as styles from "./CentreListingCard.module.scss";

import { Location, Phone } from "../../common/Icons";
import LinkNoStyle from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export interface CentreListingCardProps {
	imgUrl: string;
	url: string;
	centreName: string;
	city: string;
	postCode: string;
	phoneNumber: string;
	googleMapsUrl: string;
	distance?: number;
}

export const CentreListingCard: React.FC<CentreListingCardProps> = ({
	imgUrl,
	url,
	centreName,
	city,
	postCode,
	phoneNumber,
	googleMapsUrl,
	distance,
}) => {
	return (
		<article className={styles.centrecardcontainer}>
			<LinkNoStyle className={styles.centrename} to={url}>
				<div className={styles.centrecardimagewrapper}>
					<ProcessedImage
						className={styles.centrecardimage}
						src={imgUrl}
						alt={centreName}
						dimensions="400x300"
						width={368}
						height={276}
						loading={"lazy"}
					/>
				</div>
				<div className={styles.centrelocationcontainer}>
					<h2 className={styles.title}>{centreName}</h2>
					<div className={styles.centrelocation}>{city}</div>
					{!Number.isNaN(distance) && distance > 0 && (
						<div className={styles.distance}>{`${distance.toFixed(
							1,
						)} miles`}</div>
					)}
				</div>
			</LinkNoStyle>
			<div className={styles.cardsectionbreak} />
			<div className={styles.centrecardlinkscontainer}>
				{phoneNumber?.length > 0 && (
					<div className={styles.phone}>
						<Phone height={"20px"} width={"20px"} />
						<a href={`tel:${phoneNumber?.replace(/\s/g, "")}`}>{phoneNumber}</a>
					</div>
				)}
				{postCode?.trim()?.length > 0 && (
					<div className={styles.maplink}>
						<Location height={"20px"} width={"20px"} />
						<a href={googleMapsUrl} target="__blank">
							{postCode}
						</a>
					</div>
				)}
			</div>
		</article>
	);
};

export default CentreListingCard;
